import { Box, Grid, InputLabel, TextField, ToggleButtonGroup, ToggleButton, FormHelperText, FormControl, Select, MenuItem, FormLabel, Button, CircularProgress } from "@mui/material"
import { Controller, useForm } from "react-hook-form"
import { useTaskContext } from "../../../../shared/context/taskContext"
import { useEffect } from "react"
import SaveIcon from '@mui/icons-material/Save';
import { useOt } from "../../../../shared/context/otContext"

export default function SubtaskReview() {

    const { taskByHash, subtaskResponse, subtaskResponseHash, setSubtaskResponseHash, updateSubtaskResponse, loadingUpdateSubtaskResponse } = useTaskContext()
    const { ot } = useOt()
    const { control, formState: { errors }, reset } = useForm()

  


    //funcion para comprobar si todos los campos requeridos estan completos
    const areRequiredFieldsFilled = () => {
        for (const subtask of taskByHash.subtasks) {
            if (subtask.is_mandatory) {
                const response = subtaskResponseHash.find(item => item.code === subtask.code);
                if (!response || response.value === null || response.value === "" || (Array.isArray(response.value) && response.value.length === 0)) {
                    return false;
                }
            }
        }
        return true;
    };
 
    useEffect(() => {
        if (taskByHash) {
            // Reiniciar el formulario cuando cambia la tarea
            reset();
            
            // Inicializar las respuestas con los valores de la nueva tarea
            const newResponses = taskByHash.subtasks.map(subtask => ({
                code: subtask.code,
                value: subtask.response?.value || null,
                id: subtask.response?.id || null,
                subtask_id: subtask.id
            }));
            
            setSubtaskResponseHash(newResponses);
        }
    }, [taskByHash?.id, reset]); // Agregamos taskByHash.id como dependencia para asegurar que se actualice cuando cambia la tarea


  



    const fieldText = (subtask, typeField, onChange, required, code, readOnly) => {
        return (
            <Controller
                control={control}
                name={`subtask_${code}`}
                rules={{ required: required }}
                render={({ field }) => (
                    <TextField
                        fullWidth
                        type={typeField}
                        {...field}
                        value={subtaskResponseHash.find(item => item.code === code)?.value || ""}
                        onChange={(e) => onChange(e.target.value)}
                        error={!subtaskResponseHash.find(item => item.code === code)?.value && required}
                        helperText={!subtaskResponseHash.find(item => item.code === code)?.value && required && "Este campo es requerido"}
                        slotProps={{
                            input: {
                                readOnly: readOnly
                            }
                        }}
                    />
                )}
            />
        )
    }

    const fieldBoolean = (subtask, onChange, required, code, readOnly) => {
        return (
            <Controller
                control={control}
                name={`subtask_${code}`}
                rules={{ required: required }}
                render={({ field }) => (
                    <>
                        <ToggleButtonGroup
                            value={subtaskResponseHash.find(item => item.code === subtask.code)?.value || ""}
                            exclusive
                            onChange={(e) => onChange(e.target.value)}
                            sx={{ width: "100%", display: "flex", justifyContent: "center" }}
                            color="primary"
                            disabled={readOnly}
                        >
                            <ToggleButton value="SI" sx={{ flex: 1 }}>SI</ToggleButton>
                            <ToggleButton value="NO" sx={{ flex: 1 }}>NO</ToggleButton>
                            <ToggleButton value="N/A" sx={{ flex: 1 }}>N/A</ToggleButton>
                        </ToggleButtonGroup>
                        <FormHelperText error={!subtaskResponseHash.find(item => item.code === code)?.value && required}>
                            {!subtaskResponseHash.find(item => item.code === code)?.value && required && "Este campo es requerido"}
                        </FormHelperText>
                    </>
                )}
            />
        )
    }

    const fieldList = (subtask, options, onChange, required, code, readOnly) => {
        return (
            <FormControl fullWidth>
                <Controller
                    control={control}
                    name={`subtask_${code}`}
                    rules={{ required: required }}
                    render={({ field }) => (
                        <>
                            <Select
                                {...field}
                                onChange={(e) => {
                                    field.onChange(e);
                                    onChange(e.target.value);
                                }}
                                value={subtaskResponseHash.find(item => item.code === code)?.value || ""}
                                placeholder="Selecciona una opción"
                                disabled={readOnly}
                                sx={{
                                    ...(readOnly && {
                                        '& .MuiSelect-select': {
                                            WebkitTextFillColor: 'inherit',
                                            backgroundColor: 'transparent'
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: 'rgba(0, 0, 0, 0.23)'
                                        },
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: 'rgba(0, 0, 0, 0.23)'
                                        }
                                    })
                                }}
                            >
                                <MenuItem value="" disabled>Selecciona una opción</MenuItem>
                                {options.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>{option.value}</MenuItem>
                                ))}
                            </Select>
                            <FormHelperText error={!subtaskResponseHash.find(item => item.code === code)?.value && required}>
                                {!subtaskResponseHash.find(item => item.code === code)?.value && required && "Este campo es requerido"}
                            </FormHelperText>
                        </>
                    )}
                />
            </FormControl>
        )
    }


    return (
        <Box sx={{ padding: 2 }}>
            <Grid container spacing={2} columns={12} sx={{maxHeight: "800px", overflowY: "auto"}}>
                <Grid item size={{ xs: 12 }}>
                  { ot.status.name === "in_process" && <Button disabled={!areRequiredFieldsFilled()} onClick={() => updateSubtaskResponse()} startIcon={loadingUpdateSubtaskResponse ? <CircularProgress size={20} /> : <SaveIcon />} variant="contained" color="primary" >
                        Guardar
                    </Button>}
                </Grid>
                {taskByHash?.subtasks.map((subtask) => (
                    <Grid item size={{ xs: 12 }} key={subtask.id} >
                        <InputLabel sx={{fontSize: "13px", fontWeight: "bold"}}>{subtask.description}</InputLabel>
                        {
                             (subtask.type_field === "text" || subtask.type_field === "number" || subtask.type_field === "date" || subtask.type_field === "datetime-local") && fieldText(subtask, subtask.type_field, (value) => {
                                setSubtaskResponseHash((prev) => {
                                    const newSubtaskResponse = [...prev]
                                    const subtaskIndex = newSubtaskResponse.findIndex(item => item.code === subtask.code)
                                    if (subtaskIndex !== -1) {
                                        newSubtaskResponse[subtaskIndex].value = value
                                    }
                                    return newSubtaskResponse
                                })
                            }, subtask.is_mandatory, subtask.code, ot.status.name === "completed" || ot.status.name === "review" || ot.status.name === "cancel")
                        }
                        {
                            subtask.type_field === "boolean" && fieldBoolean(subtask, (value) => {
                                setSubtaskResponseHash((prev) => {
                                    const newSubtaskResponse = [...prev]
                                    const subtaskIndex = newSubtaskResponse.findIndex(item => item.code === subtask.code)
                                    if (subtaskIndex !== -1) {
                                        newSubtaskResponse[subtaskIndex].value = value
                                    }
                                    return newSubtaskResponse
                                })
                            }, subtask.is_mandatory, subtask.code, ot.status.name === "completed" || ot.status.name === "review" || ot.status.name === "cancel")
                        }
                        {
                            subtask.type_field === "list" && fieldList(subtask, subtask.values, (value) => {
                                console.log('value', value)
                                setSubtaskResponseHash((prev) => {
                                    const newSubtaskResponse = [...prev]
                                    const subtaskIndex = newSubtaskResponse.findIndex(item => item.code === subtask.code)
                                    if (subtaskIndex !== -1) {
                                        newSubtaskResponse[subtaskIndex].value = value
                                    }
                                    return newSubtaskResponse
                                })
                            }, subtask.is_mandatory, subtask.code, ot.status.name === "completed" || ot.status.name === "review" || ot.status.name === "cancel")
                        }
                    </Grid>
                ))}
            </Grid>
        </Box>
    )
}